module.exports = __webpack_public_path__ + "assets/library-active.e211da09.svg";